<template>
  <div>
    <div style="height: 112px;width: 85.4%;display: flex;margin-bottom: 20px">
      <div class="warningRes">
        <div class="num" style="text-align: center">
          <img src="../assets/img/timeOver.png" style="margin-top: 34px;"/>
        </div>
        <div>
          <div class="warningTitle">超时未送达</div>
          <div class="warningCount" style="margin-top:0px">{{ this.overTime }}</div>
        </div>
      </div>
      <div style="margin-left: 20px" class="warningRes">
        <div class="num" style="text-align: center;background-color: #D99319">
          <img src="../assets/img/status.png" style="margin-top: 34px"/>
        </div>
        <div>
          <div class="warningTitle">状态异常</div>
          <div class="warningCount" style="margin-top: 0">{{ this.abnormal }}</div>
        </div>
      </div>
      <div style="width: 350px;height: 112px;margin-left: 20px;background-color: #fff">
        <simple-chart :option="logisticChart.option"
                      style="margin-top:10px;width: 500px;height:100px"></simple-chart>
      </div>
      <div style="width: 350px;height: 112px;margin-left: 20px;background-color: #fff">
        <simple-chart :option="chartOption.option"
                      style="margin-top:10px;width: 500px;height:100px"></simple-chart>
      </div>
    </div>

    <div class="main-panel">

      <a-card style="width: 100%;height: 91%;">
        <a-row >
          <a-col :span="12">
            <div>
              <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
                <a-row :gutter="20">
                  <a-col :span="7">
                    <a-form-model-item label="IFS单号" :colon="false">
                      <a-input v-model="ifs" auto-complete="off" placeholder="请输入IFS单号" clearable></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-model-item label="预警原因" :colon="false">
                      <a-select v-model="warnReasonValue" placeholder="请选择处理状态" clearable>
                        <a-select-option
                          v-for="item in warnReasonValueOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-model-item label="处理状态" :colon="false">
                      <a-select v-model="value" placeholder="请选择处理状态" clearable>
                        <a-select-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="20">
                  <a-col :span="7">
                    <a-form-model-item label="时间" :colon="false">
                      <a-range-picker
                        style="width: 100%"
                        :show-time="{ format: 'HH:mm:ss' }"
                        format="YYYY-MM-DD HH:mm:ss"
                        :placeholder="['Start Time', 'End Time']"
                        v-model="time"
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-model-item label="运输方式" :colon="false">
                      <a-select v-model="transportOption" placeholder="请选择运输方式" clearable
                      >
                        <a-select-option
                          v-for="item in transportOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          {{ item.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-model-item label="发货地址" :colon="false">
                      <a-select v-model="sendCity" placeholder="请选择运输方式" clearable
                      >
                        <a-select-option
                          v-for="item in sendCityOptions"
                          :key="item.city"
                          :label="item.city"
                          :value="item.city">
                          {{ item.city }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="1">
                    <a-form-model-item label=" " :colon="false">
                      <a-button type="primary"  icon="el-icon-search" @click="search">搜索
                      </a-button>
                    </a-form-model-item>
                  </a-col>
                </a-row>

              </a-form-model>
            </div>
            <div style="margin:0 15px;height: 544px;overflow-y: auto;overflow-x: hidden">
              <div class="order-card" :key="item.id" v-for="item in tableData">
                <div style="height: 40px;border-bottom: 1px solid #dedede;">
                  <div style="margin: 0px 0 0 3px;float: left">
                    <span
                      style="font-size: 15px;display:-moz-inline-box;max-width: 165px; display:inline-block;overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">订单号：{{
                        item.orderNo
                      }}</span>
                    <span class="orderStatus" v-if="item.warningReason=='超时未送达'"
                          style="background-color: red">{{ item.warningReason }}</span>
                    <span class="orderStatus" v-else="" style="background-color: orange">{{ item.warningReason }}</span>
                    <span style="font-size: 15px"
                          v-if="item.cancelWarningReason">已处理</span>
                    <span style="font-size: 15px" v-else="">未处理</span>
                  </div>
                  <div style="margin-right: 20px;float: right">
                    <a-button plain
                              @click="insideDeal(item)">内部处理
                    </a-button>
                    <a-button plain
                              @click="getMap(item)">查看轨迹
                    </a-button>
                    <a-button class="showWarn" style="cursor: default" @click="cancelWarn(item.id)"
                              v-if="item.cancelWarningReason !== null&&item.cancelWarningReason !== ''">{{ item.cancelWarningReason }}
                    </a-button>
                    <a-button plain type="warning"
                              @click="cancelWarn(item.id)"
                              v-else>取消预警
                    </a-button>
                  </div>
                </div>
                <div style="height: 80px;    padding: 12px 12px 0 12px;">
                  <div style="color: #000;">
                    <span style="font-size: 20px">{{ item.sendCity }}</span>
                    <img src="../assets/img/rightArrow.png" style="vertical-align: middle"/>
                              <span style="font-size: 20px">{{ item.receiveCity }}</span>
                    <span
                      style="margin-left: 30px;font-size: 15px">IFS No.:{{ item.ifsNo }}</span>
                    <span
                      style="margin-left: 30px;font-size: 15px">承运商:{{ item.expressCode }}</span>
                    <span
                      style="margin-left: 30px;font-size: 15px">发货时间:
                     <date-time-formatter :date-time="item.deliveryAt"
                                          formatter="YYYY-MM-DD"></date-time-formatter></span>
                  </div>
                  <div
                    style="margin-top:25px;width: 100%;overflow: hidden; text-overflow:ellipsis; white-space: nowrap;">
                    当前位置:{{ item.currentLocation }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-color">
<!--              <a-pagination @size-change="handleSizeChange"-->
<!--                            @current-change="handleCurrentChange"-->
<!--                            :current-page="listQuery.page"-->
<!--                            :page-sizes="[3,5,10]"-->
<!--                            :page-size="listQuery.size"-->
<!--                            layout="total, sizes, prev, pager, next, jumper"-->
<!--                            :total="listQuery.totalAmount">-->
<!--              </a-pagination>-->
              <a-pagination
                :total="listQuery.totalAmount"
                :show-total="total => `Total ${listQuery.totalAmount} items`"
                :page-size="listQuery.size"
                v-model="listQuery.page"
                :default-current="1"
                @change="currentChange"
              />
            </div>
          </a-col>

          <a-col :span="12">
            <div
              style="height:600px;background-color: #fff;border:1px solid #D3D3D3;overflow: auto;">
              <gaode-map v-if="gaoDeShow" style="height: 100%" :order="order" :order-id="orderId"></gaode-map>
              <time-line v-if="timeLineShow" :order-id="orderId" :express-code="expressCode"
                         :receive-address="receiveAddress" :wms-no="wmsNo" :ifs-no="ifsNo"
                         style="height:98%;margin:5px"></time-line>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </div>


    <div class="page-dialog">
      <a-modal
        :title="dialogTitle"
        v-model="dialogVisible"
        width="300px"
        :before-close="handleClose"
        :close-on-click-modal="false">
        <div v-for="(item,index) in warnReason" :key="index" style="text-align: center"
             :class="navIndex == index ? 'warningResclick' : 'warningResList' "
             @click="selectReason(index)">
          <span style="margin-left: 12px">{{ item.reason }}</span>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <a-button plain style="border-color: #333333;color: #333333;" @click="handleClose">取消
          </a-button>
          <a-button plain style="color: #fff;background-color:#034486;" @click="submitReason">提交
          </a-button>
        </div>
      </a-modal>
    </div>


  </div>

</template>
<script>
import GaodeMap from '../components/GaodeMap.vue';
import {getWarnReasonList, chaneWarning} from '@/api/warnReson';
import {
  getWarningOrderList,
  updateWarnOrder,
  getWarnData, getCity,
} from '@/api/order';
import SimpleChart from '@/components/SimpleChart';
import TimeLine from '../components/TimeLine.vue';
import DateTimeFormatter from '../components/DateTimeFormatter';
import {saveInsideDetail} from '@/api/insideDeal';
import moment from "moment";


async function getWarningOrders() {
  console.log(this.warnReason)
  const timeScope = this.time && this.time.length === 2
    ? this.time : [null, null];
  this.gaoDeShow = false;
  this.timeLineShow = false;
  this.tableData = [];
  let startTime = '';
  let endTime = '';
  if (this.time) {
    startTime = this.time[0];
    endTime = this.time[1];
  }
  const result = await getWarningOrderList({
    startAt: timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    endAt: timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    // startAt: startTime,
    // endAt: endTime,
    status: this.value,
    page: this.listQuery.page,
    size: this.listQuery.size,
    ifs: this.ifs,
    transportType: this.transportOption,
    warnReason: this.warnReasonValue,
    sendCity: this.sendCity,
    sort: 'deliveryAt',
    direction: 'DESC'
  });
  if (result.code === 1200) {
    this.tableData = result.data.orders;
    this.listQuery.totalAmount = result.data.totalCount;
  }
}

function search() {
  this.listQuery.page = 1;
  this.getWarningOrders();
}

async function getWarnReason() {
  const result = await getWarnReasonList();
  if (result.code === 1200) {
    this.warnReason = result.data.warnReasons;
  }
}

function cancelWarn(id) {
  this.dialogVisible = true;
  this.cancelWarnReason.id = id;
  this.getWarnReason();
}

function handleClose() {
  this.dialogVisible = false;
  this.navIndex = -1;
}

function selectReason(index) {
  this.navIndex = index;
}

async function submitReason() {
  const  {reason}  = this.warnReason[this.navIndex];
  const result = await updateWarnOrder(this.cancelWarnReason.id, reason);
  if (result.code === 1200) {
    this.getWarningOrders();
  }
  this.dialogVisible = false;
}

function getMap(row) {
  if (row.transportType === 'GPS') {
    this.orderId = row.id;
    this.order = row;
    this.timeLineShow = false;
    this.gaoDeShow = true;
  } else {
    this.orderId = row.orderNo;
    this.order = row;
    this.expressCode = row.expressCode;
    this.receiveAddress = row.receiveAddress;
    this.wmsNo = row.wmsNo;
    this.ifsNo = row.ifsNo;
    this.timeLineShow = true;
    this.gaoDeShow = false;
  }
}

async function insideDeal(row) {
  let form = {
    orderId: row.id,
    isDeal: 0,
  };
  const result = await saveInsideDetail({
    orderId: row.id,
    isDeal: 0,
  });
  if (result.data.code === 1200) {
    this.$message.success("已转内部处理")
  } else {
    this.$message.error("已有记录")
  }
}

/**
 * 显示条目数
 * @param val
 */
function handleSizeChange(val) {
  this.listQuery.size = val;
  this.getWarningOrders();
}

/**
 * 当前页
 * @param val
 */
function handleCurrentChange(current, page) {
  this.listQuery.page = current;
  this.getWarningOrders();
}

function currentChange(current, page) {
  this.listQuery.page = current;
  this.getWarningOrders();
}

async function changeWarns() {
  const res = await chaneWarning();
}

async function getWarningDatas() {
  this.logisticChart.option.series[0].data = [];
  this.logisticChart.option.series[0].data = [];
  this.chartOption.option.series[0].data = [];
  this.chartOption.option.series[0].data = [];
  this.chartOption.option.series[0].data = [];
  const result = await getWarnData();
  if (result.code === 1200) {
    this.overTime = result.data.overTime;
    this.abnormal = result.data.abnormal;
    const obj = {
      name: '超时未送达',
      value: result.data.overTime,
    };
    const obj2 = {
      name: '状态异常',
      value: result.data.abnormal,
    };
    const obj3 = {
      name: '气候异常滞留',
      value: result.data.weather,
    };
    const obj4 = {
      name: '已联系快递确认',
      value: result.data.confirm,
    };
    const obj5 = {
      name: '已到客户城市未签收',
      value: result.data.customer,
    };
    this.logisticChart.option.series[0].data.push(obj);
    this.logisticChart.option.series[0].data.push(obj2);
    this.chartOption.option.series[0].data.push(obj3);
    this.chartOption.option.series[0].data.push(obj4);
    this.chartOption.option.series[0].data.push(obj5);
  }
}

async function getSendCity(){
  const res = await getCity();
  if (res.code === 1200) {
    this.sendCityOptions = res.data.sendCity;
  }
}

export default {
  components: {
    GaodeMap,
    SimpleChart,
    TimeLine,
    DateTimeFormatter,
  },
  data() {
    return {
      order: {},
      listQuery: { totalAmount: 0, page: 1, size: 3 },
      pagination: {
        current: 1,
        pageSize: 3,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['3', '10', '20', '40', '50'],
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      },
      ifs: '',
      overTime: '',
      abnormal: '',
      gaoDeShow: false,
      timeLineShow: false,
      cancelWarnReason: {
        id: '',
        cancelWarningReason: '',
      },
      logisticChart: {
        option: {
          color: ['#184190', '#D99319'],
          legend: {
            x: 'left',
            orient: 'vertical',
            data: ['超时未送达', '状态异常'],
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)',
          },
          series: [
            {
              type: 'pie',
              label: {
                normal: {
                  position: 'inner',
                  show: false,
                },
              },
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: [],
            },
          ],
        },
      },
      chartOption: {
        option: {
          color: ['#184190', '#6C8Bc8', '#D99319'],
          legend: {
            x: 'left',
            orient: 'vertical',
            data: ['气候异常滞留', '已联系快递确认', '已到客户城市未签收'],
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)',
          },
          series: [
            {
              type: 'pie',
              label: {
                normal: {
                  position: 'inner',
                  show: false,
                },
              },
              labelLine: {
                normal: {
                  show: false,
                },
              },
              data: [],
            },
          ],
        },
      },
      backgroundColor: 'red',
      orderId: '',
      expressCode: '',
      receiveAddress: '',
      wmsNo: '',
      ifsNo: '',
      contact: '',
      time: [],
      res: '',
      warnReason: [],
      navIndex: -1,
      dialogTitle: '您取消预警的原因是？',
      dialogVisible: false,
      tableData: [],
      options: [{
        value: '2',
        label: '已处理',
      }, {
        value: '3',
        label: '未处理',
      }],
      transportOptions: [{
        value: 'GPS',
        label: 'GPS方式运输',
      }, {
        value: 'THIRDPART',
        label: '快递鸟',
      }],
      value: '',
      warnReasonValue:'',
      sendCity:'',
      sendCityOptions:[],
      warnReasonValueOptions:[{
        value: '超时未送达',
        label: '超时未送达'
      },{
        value: '未揽收',
        label: '未揽收'
      },{
        value: '数据异常',
        label: '数据异常'
      },{
        value: '未出库',
        label: '未出库'
      },{
        value: 'GPSNo错误',
        label: 'GPSNo错误'
      },{
        value: '超时未运送',
        label: '超时未运送'
      },{
        value: '状态异常',
        label: '状态异常'
      }],
      transportOption: '',
    };
  },
  watch: {},

  methods: {
    getWarnReason,
    cancelWarn,
    handleClose,
    selectReason,
    getWarningOrders,
    submitReason,
    getMap,
    insideDeal,
    handleSizeChange,
    handleCurrentChange,
    currentChange,
    getWarningDatas,
    search,
    getSendCity,
    changeWarns
  },
  created() {
    this.getWarningDatas();
    this.getWarningOrders();
    this.getSendCity()
  },
  mounted() {
    // this.changeWarns();
  },
  computed: {},
};
</script>
<style>

  .order-card {
    border: 1px solid #eeeeee;
    padding: 10px;
    margin: 10px 0;
  }

  .order-card-operation-wrap {

  }

  .orderStatus {
    border-radius: 15px;
    color: #fff;
    height: 20px;
    margin: 10px;
    padding: 4px;
  }

  .el-table__body tr {
    height: 48px;
  }

  .warningRes {
    width: 36.4%;
    height: 112px;
    background: #fff
  }

  .warningRes .num {
    width: 40.4%;
    background: #184190;
    height: 112px;
    float: left;
  }

  .warningTitle {
    margin: 18px 0 5px 46.6%;
    font-family: 'PingFangSC-Medium';
    font-size: 16px;
    text-align: left;
  }

  .warningCount {
    margin: 45px 30px 0 0;
    font-family: 'BoschSans-Bold';
    font-size: 42px;
    text-align: right;
  }


</style>
<style scope="">
  .mainWarn .el-input__inner {
    border-radius: 0px;
  }

  .mainWarn .el-table .cell, .mainWarn .el-table th div, .mainWarn .el-table--border td:first-child .cell, .mainWarn .el-table--border th:first-child .cell {
    padding-left: 0px;
  }

  .mainWarn .el-table .cell, .el-table th div {
    padding-right: 0px;
  }

  .mainWarn .el-button {
    font-size: 15px;
  }

  .mainWarn .el-table td, .mainWarn .el-table th {
    border-top: 10px solid #F6F7FB;
  }

  .mainWarn .el-table tbody tr:hover > td {
    background-color: #ffffff !important
  }

  .mainWarn .el-dialog__footer {
    text-align: center;
  }

  .mainWarn .el-dialog__body {
    padding: 0px 34px 10px 34px;
  }

  .warningResList {
    height: 40px;
    text-align: left;
    background-color: #F6F6F6;
    line-height: 40px;
    margin-top: 12px;
    color: #000;
  }

  .warningResclick {
    height: 40px;
    text-align: left;
    background-color: #F6F6F6;
    line-height: 40px;
    margin-top: 12px;
    color: #000;
    border: 1px solid #000;
  }

  .showWarn {
    cursor: auto;
    background-color: #fff;
    color: #2c3e50;
  }

  .showWarn:hover {
    background-color: #fff;
    color: #2c3e50;
  }

  .pagination-color {
    margin: 20px;
    text-align: center;
  }
</style>
